import { AsyncState, Updater, loadedAsyncState, loadingAsyncState } from "widgets-for-react";
import { actualitySearch } from "../cmsPage/sharepointPageApi/sharepointPageApi";
import { ActualityPageData, PageResult } from "../cmsPage/sharepointPageApi/types/pageData";

export type ActualitySearchResult = PageResult<ActualityPageData>

export interface ActualitySearchState {
    query?: string
    page?: number
    result: AsyncState<ActualitySearchResult>
}

export const initialActualitySearchState: (query?: string, page?: string) => ActualitySearchState = 
(query, page) => {
    const intPage = parseInt((page || '1'));
    return {
        result: query
            ? loadingAsyncState(() => actualitySearch(query || '', intPage))
            : loadedAsyncState<PageResult<ActualityPageData>>({ Count: 0, PerPage: 10, Total: 0, Resources: [] }),
        query: query || '',
        page: intPage
    };
}

export const actualitySearchPageStateUpdaters = {
    updateSearchResult: (updater: Updater<AsyncState<ActualitySearchResult>>) =>
        (state: ActualitySearchState): ActualitySearchState => ({
            ...state,
            result: updater(state.result),
        }),
}